import { AfterViewInit, Component, OnDestroy, ViewChild } from '@angular/core';
import { PrepareActions } from '@app/client/uploader/store/actions';
import * as fromRoot from '@app/reducers';
import { SmashVerificationCodeComponent } from '@app/shared/modules/smash-verification-code/smash-verification-code/smash-verification-code.component';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';
import { UpdateEmailChallengeOutput } from '@smash-sdk-private/kyc/ejs/11-2023/types/UpdateEmailChallenge/UpdateEmailChallenge';
import * as fromUploader from '@app/client/uploader/store/reducers';

@Component({
  selector: 'app-email-validation',
  templateUrl: './email-validation.component.html',
  styleUrls: ['./email-validation.component.scss']
})
export class EmailValidationComponent implements OnDestroy, AfterViewInit {

  @ViewChild('verificationCode') verificationCodeComponent: SmashVerificationCodeComponent;

  verifyEmailLoading$: Observable<boolean>;
  verifyEmailLoaded$: Observable<boolean>;
  verifyEmailError$: Observable<any>;

  validateEmailVerificationCodeResponse$: Observable<UpdateEmailChallengeOutput['emailChallenge']['status']>;
  validateEmailVerificationCodeLoading$: Observable<boolean>;
  validateEmailVerificationCodeLoaded$: Observable<boolean>;
  validateEmailVerificationCodeError$: Observable<any>;

  sendEmailVerificationLoading$: Observable<boolean>;
  sendEmailVerificationLoaded$: Observable<boolean>;
  sendEmailVerificationError$: Observable<any>;

  transferLinkParameters$: Observable<any>;
  transferEmailParameters$: Observable<any>;

  uploadFormMode$: Observable<any>;

  verificationCodeFormDisplayed$: Observable<boolean>;

  subscriptions = [];
  submitted = false;

  constructor(private store$: Store<fromRoot.State & fromUploader.State>) {
    this.validateEmailVerificationCodeResponse$ = this.store$.select(fromUploader.getValidateEmailVerificationCodeResponse);
    this.validateEmailVerificationCodeLoading$ = this.store$.select(fromUploader.getValidateEmailVerificationCodeLoading);
    this.validateEmailVerificationCodeLoaded$ = this.store$.select(fromUploader.getValidateEmailVerificationCodeLoaded);
    this.validateEmailVerificationCodeError$ = this.store$.select(fromUploader.getValidateEmailVerificationCodeError);

    this.verifyEmailLoading$ = this.store$.select(fromUploader.getVerifyEmailLoading);
    this.verifyEmailLoaded$ = this.store$.select(fromUploader.getVerifyEmailLoaded);
    this.verifyEmailError$ = this.store$.select(fromUploader.getVerifyEmailError);

    this.sendEmailVerificationLoading$ = this.store$.select(fromUploader.getSendEmailVerificationLoading);
    this.sendEmailVerificationLoaded$ = this.store$.select(fromUploader.getSendEmailVerificationLoaded);
    this.sendEmailVerificationError$ = this.store$.select(fromUploader.getSendEmailVerificationError);

    this.verificationCodeFormDisplayed$ = this.store$.select(fromUploader.getVerificationCodeFormDisplayed);

    this.transferEmailParameters$ = this.store$.select(fromUploader.getTransferEmailParameters);
    this.transferLinkParameters$ = this.store$.select(fromUploader.getTransferLinkParameters);

    this.uploadFormMode$ = this.store$.select(fromUploader.getUploadFormMode);

    this.subscriptions.push(
      this.validateEmailVerificationCodeResponse$.subscribe((response) => {
        if (!!response) {
          this.verificationCodeComponent.reset();
        }
      }),
      this.validateEmailVerificationCodeError$.subscribe((error) => {
        if (!!error) {
          this.verificationCodeComponent.reset();
        }
      }),
    );
  }

  ngAfterViewInit(): void {
    if (this.verificationCodeComponent) {
      // FIXME
      setTimeout(() => {
        this.verificationCodeComponent.focus();
      }, 0);
    }
  }

  submit() {
    this.submitted = true;
    if (this.verificationCodeComponent.valid) {

    } else {
      this.verificationCodeComponent.focus();
    }
  }

  async onVerificationChange(value: number) {
    const uploadFormMode = await this.uploadFormMode$.pipe(take(1)).toPromise();
    const transferLinkParameters = await this.transferLinkParameters$.pipe(take(1)).toPromise();
    const transferEmailParameters = await this.transferEmailParameters$.pipe(take(1)).toPromise();
    const username = uploadFormMode === 'link' ? transferLinkParameters.delivery.sender.email : transferEmailParameters.delivery.sender.email;
    this.store$.dispatch(PrepareActions.ValidateEmailVerificationCode({ username, code: value }));
  }

  async handleSendAgain() {
    const uploadFormMode = await this.uploadFormMode$.pipe(take(1)).toPromise();
    const transferLinkParameters = await this.transferLinkParameters$.pipe(take(1)).toPromise();
    const transferEmailParameters = await this.transferEmailParameters$.pipe(take(1)).toPromise();
    const username = uploadFormMode === 'link' ? transferLinkParameters.delivery.sender.email : transferEmailParameters.delivery.sender.email;
    this.store$.dispatch(PrepareActions.SendEmailVerificationCode({ username }));
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }
}
